import { render, staticRenderFns } from "./MenuPerSon.vue?vue&type=template&id=bec7f3e4&scoped=true"
import script from "./MenuPerSon.vue?vue&type=script&lang=js"
export * from "./MenuPerSon.vue?vue&type=script&lang=js"
import style0 from "./MenuPerSon.vue?vue&type=style&index=0&id=bec7f3e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec7f3e4",
  null
  
)

export default component.exports